import Icon, { Icons } from '@/presentation/components/elements/Icon';

const WithdrawLiquidityLoading = () => {
  return (
    <div className="p-4 space-y-4">
      <h1 className="font-bold text-lg">Remove Liquidity</h1>
      <div className="text-center p-4">
        <Icon
          name={Icons.SPINNER_GAP}
          className="animate-spin inline-flex"
          size={24}
        />
      </div>
    </div>
  );
};

export default WithdrawLiquidityLoading;
